import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { BsCurrencyExchange } from "react-icons/bs";
import { useIframeSettings } from "../_helpers/IframeSettingsContext";

// Currency switcher: an exchange icon that opens a menu of allowedCurrencies.
// Shows only when switching is allowed; the selected code is highlighted.
// On select, updates shared context (no reload) so price fetches re-run with the new currency.
export default function CurrencyDropdown({ themeData, className = "" }) {
    const { currency, setCurrency } = useIframeSettings();
    const allow =
        themeData &&
        themeData.allowCurrencyChange &&
        themeData.allowCurrencyChange.toString() !== "0";

    const options =
        allow && themeData.allowedCurrencies
            ? themeData.allowedCurrencies.split(",").map((c) => c.trim()).filter(Boolean)
            : [];

    const [anchorEl, setAnchorEl] = useState(null);

    if (!allow || options.length === 0) return null;

    const current = options.includes(currency) ? currency : options[0];

    const handleSelect = (code) => {
        setAnchorEl(null);
        setCurrency(code);
    };

    return (
        <div className={`iframe-currency d-inline-flex align-items-center ${className}`}>
            <IconButton
                size="small"
                title="Change currency"
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <BsCurrencyExchange style={{ fontSize: 22 }} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{
                    style: {
                        maxHeight: 240,
                        backgroundColor: themeData?.nav_bar_color || "#fff",
                    },
                }}
            >
                {options.map((code) => (
                    <MenuItem
                        key={code}
                        selected={code === current}
                        onClick={() => handleSelect(code)}
                    >
                        {code}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
